import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, isRef as _isRef, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "pagination pt-3 pb-2" }
const _hoisted_2 = {
  key: 0,
  class: "float-start"
}
const _hoisted_3 = { class: "float-start me-2" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "las la-step-backward" }, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "float-start me-2" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "las la-play" }, null, -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "float-start me-2 pages" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", null, " ... ", -1)
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "float-start me-2" }
const _hoisted_18 = ["disabled"]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", { class: "las la-play" }, null, -1)
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = { class: "float-start me-5" }
const _hoisted_22 = ["disabled"]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", { class: "las la-step-forward" }, null, -1)
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "float-start pt-1 text-end" }, " idź do strony: ", -1)
const _hoisted_26 = { class: "float-start ms-2 go-to-page-input" }
const _hoisted_27 = { class: "float-start ms-2" }
const _hoisted_28 = {
  key: 1,
  class: "float-start"
}
const _hoisted_29 = ["value"]
const _hoisted_30 = ["value"]
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "float-start pt-1 ms-2" }, " na stronie ", -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "clearfix" }, null, -1)
const _hoisted_33 = {
  key: 2,
  class: "pt-1"
}

import { PaginationData } from '../store/speedprint/models/paginationData';
    import { state } from '@/store/speedprint/state';
    import { ref } from 'vue';
 
    
export default /*#__PURE__*/_defineComponent({
  __name: 'Paging',
  props: {
    pagingData: {},
    padding: { type: Boolean }
  },
  emits: ["goToPage", "setItemsPerPage"],
  setup(__props: any, { emit }) {

const props = __props;

    const config = state.config;
    
    
    const setItemsPerPage = (e:Event) => {
        emit('setItemsPerPage', parseInt((e.target as HTMLInputElement).value));
    }
    let from = () => { return ((props.pagingData.pageNumber - 1) * props.pagingData.itemsPerPage + 1) };
    let to = () => { 
        var calculatedTo = props.pagingData.pageNumber * props.pagingData.itemsPerPage;
        return calculatedTo > props.pagingData.totalCount ? props.pagingData.totalCount : calculatedTo;
    };
    let totalPages = () => { return props.pagingData.totalPages };
    let pageNumber = () => {return props.pagingData.pageNumber };

    var pageToGoTo = ref(1);

    let pagingArray = () => {
		var a = [];
		var offset = totalPages() > 10 ? pageNumber() > 4 ? (pageNumber() - 3) : 0 : 0;
        var end = totalPages() > 10 ? pageNumber() > 4 ? (pageNumber() + 2) : 8 : totalPages(); 

		for (var p = offset; p < end; p++) {
			p < totalPages() ? a.push(p + 1) : null;
		}
		return a;
	}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      (_unref(totalPages)() > 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("button", {
                class: "btn btn-sm btn-outline-primary",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('goToPage',1))),
                disabled: !props.pagingData.hasPreviousPage
              }, _hoisted_6, 8, _hoisted_4)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("button", {
                class: "btn btn-sm btn-primary flip-text",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('goToPage', _unref(pageNumber)() - 1))),
                disabled: !props.pagingData.hasPreviousPage
              }, _hoisted_10, 8, _hoisted_8)
            ]),
            _createElementVNode("div", _hoisted_11, [
              (_unref(totalPages)() > 10 && _unref(pageNumber)() > 4)
                ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                    _createElementVNode("span", {
                      class: "p-number",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('goToPage', 1)))
                    }, "1"),
                    _hoisted_13
                  ]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(pagingArray)(), (page) => {
                return (_openBlock(), _createElementBlock("span", {
                  class: _normalizeClass(["p-number me-2", _unref(pageNumber)() == page ? 'current' : '']),
                  key: page
                }, [
                  _createElementVNode("a", {
                    onClick: ($event: any) => (_ctx.$emit('goToPage', page))
                  }, _toDisplayString(page), 9, _hoisted_14)
                ], 2))
              }), 128)),
              (_unref(totalPages)() > 10 && _unref(pageNumber)() <= (_unref(totalPages)()-3))
                ? (_openBlock(), _createElementBlock("span", _hoisted_15, [
                    (_unref(pageNumber)() != _unref(totalPages)() - 3)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_16, " ... "))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", {
                      class: "p-number",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('goToPage', _unref(totalPages)())))
                    }, _toDisplayString(_unref(totalPages)()), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("button", {
                class: "btn btn-sm btn-primary",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('goToPage', _unref(pageNumber)() + 1))),
                disabled: !props.pagingData.hasNextPage
              }, _hoisted_20, 8, _hoisted_18)
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("button", {
                class: "btn btn-sm btn-primary",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('goToPage', _unref(totalPages)()))),
                disabled: !props.pagingData.hasNextPage
              }, _hoisted_24, 8, _hoisted_22)
            ]),
            _hoisted_25,
            _createElementVNode("div", _hoisted_26, [
              _withDirectives(_createElementVNode("input", {
                type: "number",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_isRef(pageToGoTo) ? (pageToGoTo).value = $event : pageToGoTo = $event)),
                class: "form-control form-control-sm",
                onChange: _cache[7] || (_cache[7] = () => { if(_unref(pageToGoTo) > _unref(totalPages)() || _unref(pageToGoTo) < 1) { _isRef(pageToGoTo) //@ts-ignore
 ? pageToGoTo.value = 1 : pageToGoTo = 1 }}),
                onKeyup: _cache[8] || (_cache[8] = _withKeys(($event: any) => (_ctx.$emit('goToPage', _unref(pageToGoTo))), ["enter"]))
              }, null, 544), [
                [_vModelText, _unref(pageToGoTo)]
              ])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("button", {
                class: "btn btn-sm btn-primary",
                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('goToPage', _unref(pageToGoTo))))
              }, "GO")
            ])
          ]))
        : _createCommentVNode("", true),
      (_unref(totalPages)() > 1 || (_unref(totalPages)() == 1 && props.pagingData.totalCount > _unref(config).itemsPerPage[0]))
        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
            _createElementVNode("div", {
              class: _normalizeClass(["float-start", _unref(totalPages)() > 1 ? 'ms-5' : ''])
            }, [
              _createElementVNode("select", {
                class: "form-select form-select-sm",
                value: _ctx.pagingData.itemsPerPage,
                onChange: _cache[10] || (_cache[10] = ($event: any) => (setItemsPerPage($event)))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(config).itemsPerPage, (num) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: num,
                    value: num
                  }, _toDisplayString(num), 9, _hoisted_30))
                }), 128))
              ], 40, _hoisted_29)
            ], 2),
            _hoisted_31
          ]))
        : _createCommentVNode("", true),
      _hoisted_32,
      (_unref(totalPages)() > 1 || (_unref(totalPages)() == 1 && props.pagingData.totalCount > _unref(config).itemsPerPage[0]))
        ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
            _createTextVNode(" Elementy "),
            _createElementVNode("strong", null, _toDisplayString(_unref(from)()), 1),
            _createTextVNode(" do "),
            _createElementVNode("strong", null, _toDisplayString(_unref(to)()), 1),
            _createTextVNode(" z "),
            _createElementVNode("strong", null, _toDisplayString(props.pagingData.totalCount), 1)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})